import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastProvider } from 'react-toast-notifications';
import history from './utils/history';
// import * as Sentry from '@sentry/react';


import AppRouter from './router/AppRouter';

const App = () => {
    useEffect(() => {
        const isSupported = () =>
            'Notification' in window &&
            'serviceWorker' in navigator &&
            'PushManager' in window;

        let isCancelled = false;

        if (!isCancelled && isSupported()) {
            (function requestNotification() {
                if (Notification.permission !== 'denied') {
                    Notification.requestPermission();
                }
            })();
        }

        return () => {
            isCancelled = true;
        };
    }, []);

    return (
        // <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
            <ToastProvider>
                <Router history={history}>
                    <AppRouter />
                </Router>
            </ToastProvider>
        // </Sentry.ErrorBoundary>
    );
};

export default App;
